import React from 'react'

import './style.scss'

import mt from '../../images/logo-white.svg'
import wt from '../../images/wt-logo-horizontal.png'
import wt2 from '../../images/wt-logo.svg'

const Logo = props => {
  function renderLogo(site) {
    switch (site) {
      case 'mt':
        return mt
      case 'wt':
        return wt
      case 'wt2':
        return wt2
      default:
        return mt
    }
  }
  return (
    <img className="logo" src={renderLogo(props.site)} alt="M&amp;T Logo" />
  )
}

export default Logo
